// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","810":"1f803228","885":"75fc9c18"}[chunkId] + "-" + {"678":"ea36d7de1a2f40501b4b","810":"ef500ea33388eac0c608","885":"c131236ce31f94a77fb8"}[chunkId] + ".js";
};